export class MotivoDesligamento {
    id: number;
    motivoDesligamento: string;
}